import React from 'react';
import classNames from 'classnames';

import PaymentMethods from '../assets/img/payment-methods.png';
import { IS_STAGING_ENV } from '../constants';

const Footer = () => {
  return (
    <div className={classNames('footer', IS_STAGING_ENV && 'staging_footer')}>
      <div className="whatsapp-help">
        <a href="https://wa.me/249999990558" target="_blank" rel="noreferrer">
          <i style={{color:'#FFFFFF'}} className="fab fa-3x fa-whatsapp tooltip"><span className="right-tooltip-text">تواصل مع فريق العمل</span></i>
        </a>
      </div>
      <img src={PaymentMethods} width={128} alt="وسائل الدفع" />
      <div style={{marginTop:16}}>صنع بحب <span style={{color: '#ef5350'}}>&hearts;</span> بواسطة <a href="https://eptikar.com" target='_blank' rel="noreferrer">إبتكار</a></div>
    </div>
  );
};

export default Footer;